import { type ErrorResponse } from '@apollo/client/link/error';

export function logGraphQLErrorResponse(error: ErrorResponse): void {
  const { graphQLErrors, networkError, operation } = error;

  if (graphQLErrors) {
    for (const error_ of graphQLErrors) {
      console.debug(
        `[GraphQL error]: Message: ${error_.message}, Location: ${JSON.stringify(error_.locations)}, Path: ${error_.path}`,
        {
          operation: operation.operationName,
          variables: operation.variables,
        }
      );
    }
  }

  if (networkError) {
    console.debug(`[Network error]: ${networkError}`, {
      operation: operation.operationName,
      variables: operation.variables,
    });
  }
}
